import { render, staticRenderFns } from "./AssessmentTimer.vue?vue&type=template&id=97ac6d34&"
import script from "./AssessmentTimer.vue?vue&type=script&lang=js&"
export * from "./AssessmentTimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports